<span> <img [src]="imgPath" height="50px" width="40px" [alt]="fileDesc" style="margin-top:-11px"> </span>
